module.exports = __webpack_public_path__ + "img/ug111.6f80495a.png";